import DocusaurusFooter from '../DocusaurusFooter'
import {
  Color,
  List,
  Paragraph
} from '@eggplant/pattern-library'
import { runnerViewAll } from '../../docs-routes'

const RunHistoryResultDescription = () =>
  <Paragraph>
    <Color
      display='inline'
      variant='theme-description-text'
    >
      The overall result of the test config run. Determined by the combined results of the test steps within.
      <List variant='description'>
        <Paragraph>
          <Color variant='theme-description-text'>
            Passed: All test steps are passed
          </Color>
        </Paragraph>
        <Paragraph>
          <Color variant='theme-description-text'>
            Failed: One or more test steps failed
          </Color>
        </Paragraph>
        <Paragraph>
          <Color variant='theme-description-text'>
            Error: One or more test steps errored
          </Color>
        </Paragraph>
        <Paragraph>
          <Color variant='theme-description-text'>
            Cancelled: Test run cancelled
          </Color>
        </Paragraph>
      </List>
    </Color>
    <DocusaurusFooter path={runnerViewAll} />
  </Paragraph>

export default RunHistoryResultDescription
